import { DATE_RANGE } from '../../constants/cenariusDimensions';
import { DrilldownMapperBase } from './DrilldownMapperBase';

type Column = { key: string };

export class DrilldownMapperDown extends DrilldownMapperBase {
  private _dimensions?: string[] = undefined;

  private _columns?: Column[] = undefined;

  private calculateDimensions() {
    if (this.hasGranularityDimension) {
      return [DATE_RANGE].concat(...this.dimensions.filter((d) => !(d in this.dimensionToGranularityMap)));
    }

    return this.dimensions;
  }

  private calculateColumns() {
    const dimensions = this.getDimensions();
    const dimensionColumns = dimensions.map((dimension) => ({ key: dimension }));

    const columns = this.selectedColumns.filter(
      (selectedColumn) => !dimensions.includes(selectedColumn.key) && !this.dimensionToGranularityMap[selectedColumn.key]
    );

    return [...dimensionColumns, ...columns];
  }

  needsUpdate() {
    return this.hasGranularityDimension;
  }

  getSelectedColumns() {
    if (this._columns === undefined) {
      this._columns = this.calculateColumns();
    }
    return this._columns;
  }

  getDimensions() {
    if (this._dimensions === undefined) {
      this._dimensions = this.calculateDimensions();
    }
    return this._dimensions;
  }

  getGranularity(): string | undefined {
    const granularityDimension = this.dimensions.find((d) => d in this.dimensionToGranularityMap);

    if (granularityDimension && this.granularityIsAll) {
      return this.dimensionToGranularityMap[granularityDimension];
    }

    return this.granularity;
  }

  getActiveHeader(): string {
    const columns = this.getSelectedColumns();
    const backupActiveHeader = columns[0].key;

    if (!this.activeHeader) {
      return backupActiveHeader;
    }

    return columns.some((c) => c.key === this.activeHeader) ? this.activeHeader : backupActiveHeader;
  }
}
